module.exports = __webpack_public_path__ + "static/channel-5-707749b714c21d23abaf392391a1e632.png";